import React from 'react';
import PropTypes from 'prop-types';
import MediaHeroSection from './MediaHeroSection';

// This is a wrapper component that configures MediaHeroSection with specific props
// for the landing page hero section with a background image instead of a video
const NewMediaHeroSection = props => {
  const { sectionId } = props;

  // Use an existing image for the background that matches the colorful wave design shown in mockup
  // We're using the editorials image which has similar vibrant colors
  const backgroundImage = require('../../assets/sell_your_icon_desktop.webp');
  const backgroundImageMobile = require('../../assets/sell_your_icon_mobile.webp');

  return (
    <MediaHeroSection
      sectionId={sectionId}
      backgroundColorDesktop="#F3B1CF"
      backgroundColorMobile="#F3B1CF"
      titleText=""
      subtitleText=""
      mediaType="video"
      // Keep video props for future use, but they won't be displayed when backgroundImage is provided
      // mediaSrc={require('../../assets/Desktop-W022.mp4')}
      // mediaDesktopSrc={require('../../assets/Desktop-W022.mp4')}
      // mediaMobileSrc={require('../../assets/Mobile-W02.mp4')}
      // New background image props that will override the color
      backgroundImage={backgroundImage}
      backgroundImageMobile={backgroundImageMobile}
      backgroundVideo={true}
      mediaAlt="Colorful abstract background"
      primaryButtonText="Create Listing"
      secondaryButtonText="Sign up"
      primaryButtonLink="NewListingPage"
      secondaryButtonLink="SignupPage"
      onPrimaryClick={() => {}}
      onSecondaryClick={() => {}}
    />
  );
};

NewMediaHeroSection.propTypes = {
  sectionId: PropTypes.string.isRequired,
};

export default NewMediaHeroSection;
